import { callApi } from "./Api";
import { actionCreator } from "./helpers";
//import { isUndefined, isEmpty } from 'lodash'
import isNil from "lodash/isNil";
import { pushParamsToUrl } from "../utils/utility";

export const STATS_BY_DEVICE_TYPE = "STATS_BY_DEVICE_TYPE";
export const STATS_BY_DEVICE_MODEL = "STATS_BY_DEVICE_MODEL";
export const STATS_BY_OS_TYPE = "STATS_BY_OS_TYPE";
export const STATS_BY_TIME = "STATS_BY_TIME";
export const STATS_BY_POPULAR_PAGE = "STATS_BY_POPULAR_PAGE";
export const STATS_BY_REGIONAL_TRAFFIC = "STATS_BY_REGIONAL_TRAFFIC";
export const STATS_BY_TIME_OF_DAY = "STATS_BY_TIME_OF_DAY";
export const STATS_BY_DEMOGRAPHIC = "STATS_BY_DEMOGHAPHIC";
export const STATS_BY_PRIMARY_DEVICES = "STATS_BY_PRIMARY_DEVICES";
export const STATS_TOP_ATTRIBUTES = "STATS_TOP_ATTRIBUTES";
export const GET_HEAT_MAP_DATA = "GET_HEAT_MAP_DATA";
export const SET_REPORT_DAY_RANGE = "SET_REPORT_DAY_RANGE";
export const SET_REPORT_GRANULARITY = "SET_REPORT_GRANULARITY";
export const SET_REPORT_WEBSITE_ID = "SET_REPORT_WEBSITE_ID";
export const CLEAR_ALL_STATS = "CLEAR_ALL_STATS";
export const GET_AUDIENCE_FILES_DATA = "GET_AUDIENCE_FILES_DATA";
export const CLEAR_AUDIENCE_FILES_DATA = "CLEAR_AUDIENCE_FILES_DATA";
export const GET_TAG_AUDIENCE_FILES = "GET_TAG_AUDIENCE_FILES";
export const DOWNLOAD_AUDIENCE_FILES = "DOWNLOAD_AUDIENCE_FILES";
export const SEND_ASSIST_REQUEST = "SEND_ASSIST_REQUEST";
export const OVERVIEW_TRAFFIC_REPORT = "OVERVIEW_TRAFFIC_REPORT";
export const DOMESTIC_CONSUMER_VISITS_REPORT =
  "DOMESTIC_CONSUMER_VISITS_REPORT";
export const DOMESTIC_BUSINESS_STATS = "DOMESTIC_BUSINESS_STATS";
export const CLEAR_ALL_DOMESTIC_STATS = "CLEAR_ALL_DOMESTIC_STATS";
export const GET_DOMESTIC_VISITS = "GET_DOMESTIC_VISITS";
export const GET_TOP_20_FREQUENCY_BUSINESSES =
  "GET_TOP_20_FREQUENCY_BUSINESSES";
export const GET_SEGMENT_DISTRIBUTION = "GET_SEGMENT_DISTRIBUTION";
export const GET_TOP_5_OS_BREAKDOWN_REPORT = "GET_TOP_5_OS_BREAKDOWN_REPORT";
export const GET_SEGMENT_DISTRIBUTION_DETAIL_REPORT =
  "GET_SEGMENT_DISTRIBUTION_DETAIL_REPORT";
export const GET_SEGMENT_DISTRIBUTION_DEVICE_MODEL_REPORT =
  "GET_SEGMENT_DISTRIBUTION_DEVICE_MODEL_REPORT";
export const GET_SEGMENT_DISTRIBUTION_DEVICE_TYPE_REPORT =
  "GET_SEGMENT_DISTRIBUTION_DEVICE_TYPE_REPORT";
export const GET_INSIGHTS_POPULAR_PAGES = "GET_INSIGHTS_POPULAR_PAGES";
export const SET_PAGE_FAVORITE = "SET_PAGE_FAVORITE";
export const GET_FAVORITE_PAGES = "GET_FAVORITE_PAGES";
export const SAVE_FAVORITE_PAGES = "SAVE_FAVORITE_PAGES";
export const GET_HEATMAP_DATA = "GET_HEATMAP_DATA";

export const GET_BY_STATES = "GET_BY_STATES";

export const GET_SEGMENT_DISTRIBUTION_SYSTEMS =
  "GET_SEGMENT_DISTRIBUTION_SYSTEMS";

export const setReportGranularity = actionCreator(SET_REPORT_GRANULARITY);
export const setReportDayRange = actionCreator(SET_REPORT_DAY_RANGE);
export const setReportWebSiteId = actionCreator(SET_REPORT_WEBSITE_ID);
export const clearAllStats = actionCreator(CLEAR_ALL_STATS);
export const clearAudienceFilesData = actionCreator(CLEAR_AUDIENCE_FILES_DATA);
export const clearAllDomesticStats = actionCreator(CLEAR_ALL_DOMESTIC_STATS);

export const GET_CULTURE_CODE_REPORT = "GET_CULTURE_CODE_REPORT";

export const getStatsByDeviceType = (siteId, dateRange, type, popUrl) => {
  const typeParam = type && type.toLowerCase() === "consumer" ? "c" : "b";

  return (dispatch, getState) => {
    let url = `insights/${siteId}/visits/by-device-type/${dateRange}?t=${typeParam}`;
    if (popUrl) {
      url += `&p=${popUrl}`;
    }
    callApi(dispatch, getState, STATS_BY_DEVICE_TYPE, url);
  };
};

export const getStatsByDeviceModel = (siteId, dateRange, type) => {
  const typeParam = type && type.toLowerCase() === "consumer" ? "c" : "b";

  return (dispatch, getState) => {
    const url = `insights/${siteId}/visits/by-device-model/${dateRange}?t=${typeParam}`;
    callApi(dispatch, getState, STATS_BY_DEVICE_MODEL, url);
  };
};

export const getStatsByOsType = (siteId, dateRange, type) => {
  const typeParam = type && type.toLowerCase() === "consumer" ? "c" : "b";

  return (dispatch, getState) => {
    const url = `insights/${siteId}/visits/by-os-type/${dateRange}?t=${typeParam}`;
    callApi(dispatch, getState, STATS_BY_OS_TYPE, url);
  };
};

export const getStatsByTime = (siteId, dateRange, page, type) => {
  const typeParam = type
    ? type.toLowerCase() === "consumer"
      ? "c"
      : "b"
    : null;
  let url = `insights/${siteId}/visits/time-series/${dateRange}`;
  if (typeParam) {
    url += `?t=${typeParam}`;
  }
  if (!isNil(page)) {
    if (typeParam) url += `&p=${page}`;
    else url += `?p=${page}`;
  }

  return (dispatch, getState) => {
    callApi(dispatch, getState, STATS_BY_TIME, url);
  };
};

export const getStatsByPopularPage = (siteId, dateRange, type) => {
  const typeParam = type
    ? type.toLowerCase() === "consumer"
      ? "c"
      : "b"
    : null;

  return (dispatch, getState) => {
    const url = typeParam
      ? `insights/${siteId}/visits/popular-pages/${dateRange}?t=${typeParam}`
      : `insights/${siteId}/visits/popular-pages/${dateRange}`;
    callApi(dispatch, getState, STATS_BY_POPULAR_PAGE, url);
  };
};

export const getStatsByRegionalTraffic = (siteId, dateRange, page, type) => {
  const typeParam = type
    ? type.toLowerCase() === "consumer"
      ? "c"
      : "b"
    : null;
  let url = `insights/${siteId}/visits/by-states/${dateRange}`;
  if (typeParam) {
    url += `?t=${typeParam}`;
  }
  if (!isNil(page)) {
    if (typeParam) url += `&p=${page}`;
    else url += `?p=${page}`;
  }

  return (dispatch, getState) => {
    callApi(dispatch, getState, STATS_BY_REGIONAL_TRAFFIC, url);
  };
};

export const getStatsByTimeofDay = (siteId, dateRange, page, type) => {
  const typeParam = type
    ? type.toLowerCase() === "consumer"
      ? "c"
      : "b"
    : null;
  let url = `insights/${siteId}/visits/by-time-of-day/${dateRange}`;
  if (typeParam) {
    url += `?t=${typeParam}`;
  }
  if (!isNil(page)) {
    if (typeParam) url += `&p=${page}`;
    else url += `?p=${page}`;
  }

  return (dispatch, getState) => {
    callApi(dispatch, getState, STATS_BY_TIME_OF_DAY, url);
  };
};

export const getStatsByDemographic = (
  siteId,
  dateRange,
  page,
  type,
  granularity,
) => {
  const typeParam = type
    ? type.toLowerCase() === "consumer"
      ? "c"
      : "b"
    : null;
  let url = `insights/${siteId}/visits/demographic-stats/${dateRange}`;
  if (typeParam) {
    url += `?t=${typeParam}`;
  }
  if (!isNil(page)) {
    if (typeParam) url += `&p=${page}`;
    else url += `?p=${page}`;
  }
  url = pushParamsToUrl(url, "granularity", granularity);
  return (dispatch, getState) => {
    callApi(dispatch, getState, STATS_BY_DEMOGRAPHIC, url);
  };
};

export const getStatsByPrimaryDevices = (siteId, dateRange, page) => {
  let url = `insights/${siteId}/visits/by-primary-device-type/${dateRange}`;
  if (!isNil(page)) {
    url += `?p=${page}`;
  }

  return (dispatch, getState) => {
    callApi(dispatch, getState, STATS_BY_PRIMARY_DEVICES, url);
  };
};

export const getStatsTopAttributes = (
  siteId,
  dateRange,
  page,
  type,
  granularity,
) => {
  const typeParam = type
    ? type.toLowerCase() === "consumer"
      ? "c"
      : "b"
    : null;
  let url = `insights/${siteId}/visits/top-attributes/${dateRange}`;
  if (typeParam) {
    url += `?t=${typeParam}`;
  }
  if (!isNil(page)) {
    if (typeParam) url += `&p=${page}`;
    else url += `?p=${page}`;
  }
  url = pushParamsToUrl(url, "granularity", granularity);
  return (dispatch, getState) => {
    callApi(dispatch, getState, STATS_TOP_ATTRIBUTES, url);
  };
};

export const getHeatMapData = (siteId, dateRange, page, type) => {
  const typeParam = type
    ? type.toLowerCase() === "consumer"
      ? "c"
      : "b"
    : null;
  let url = `insights/${siteId}/visits/heat-map/${dateRange}`;
  if (typeParam) {
    url += `?t=${typeParam}`;
  }
  if (!isNil(page)) {
    if (typeParam) url += `&p=${page}`;
    else url += `?p=${page}`;
  }
  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_HEAT_MAP_DATA, url);
  };
};

export const getAudienceFilesData = tagId => {
  return (dispatch, getState) => {
    const url = `insights/${tagId}/insights-files`;
    callApi(dispatch, getState, GET_AUDIENCE_FILES_DATA, url);
  };
};

export const getTagAudienceFiles = tagId => {
  return (dispatch, getState) => {
    const url = `insights/insights-files/${tagId}`;
    callApi(dispatch, getState, GET_TAG_AUDIENCE_FILES, url);
  };
};

export const downloadTagAudienceFile = fileId => {
  return (dispatch, getState) => {
    const url = `insights/insights-files/${fileId}/download`;
    callApi(dispatch, getState, DOWNLOAD_AUDIENCE_FILES, url);
  };
};

export const sendAssistRequest = data => {
  return (dispatch, getState) => {
    callApi(
      dispatch,
      getState,
      SEND_ASSIST_REQUEST,
      "insights/assist/request",
      {
        method: "POST",
        body: JSON.stringify(data),
      },
    );
  };
};

export const getOverviewTrafficeReport = (tagId, dateRange) => {
  const url = `insights/${tagId}/visits/overview/${dateRange}`;
  return (dispatch, getState) => {
    callApi(dispatch, getState, OVERVIEW_TRAFFIC_REPORT, url);
  };
};

export const getDomesticConsumerStats = (tagId, dateRange, granularity) => {
  let url = `insights/${tagId}/visits/domestic-consumer-stats/${dateRange}`;
  url = pushParamsToUrl(url, "granularity", granularity);
  return (dispatch, getState) => {
    callApi(dispatch, getState, DOMESTIC_CONSUMER_VISITS_REPORT, url);
  };
};

export const getDomesticBusinessStats = (tagId, dateRange, granularity) => {
  const url = granularity
    ? `insights/${tagId}/visits/domestic-business-stats/${dateRange}?granularity=${granularity}`
    : `insights/${tagId}/visits/domestic-business-stats/${dateRange}`;
  return (dispatch, getState) => {
    callApi(dispatch, getState, DOMESTIC_BUSINESS_STATS, url);
  };
};


export const getDomesticVisits = (tagId, dateRange, type, page) => {
  const typeParam = type
    ? type.toLowerCase() === "consumer"
      ? "c"
      : "b"
    : null;
  let url = `insights/${tagId}/visits/${dateRange}`;
  if (typeParam) {
    url += `?t=${typeParam}`;
  }
  if (!isNil(page)) {
    if (typeParam) url += `&p=${page}`;
    else url += `?p=${page}`;
  }

  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_DOMESTIC_VISITS, url);
  };
};

export const getTop20FrequencyBusiness = (tagId, dateRange) => {
  const url = `insights/${tagId}/visits/top-companies/${dateRange}`;
  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_TOP_20_FREQUENCY_BUSINESSES, url);
  };
};

export const getSegmentDistribution = (
  tagId,
  segment,
  dateRange,
  granularity,
  page,
) => {
  const url = page
    ? `insights/${tagId}/segment-distribution/${segment}/${dateRange}?page=${page}`
    : `insights/${tagId}/segment-distribution/${segment}/${dateRange}`;
  window.localStorage.setItem("__segmentSysId__", segment);
  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_SEGMENT_DISTRIBUTION, url);
  };
};

export const getSegmentReportTop5OS = (
  tagId,
  segment,
  dateRange,
  segmentIds,
  granularity,
  page,
) => {
  let url = segmentIds
    ? `insights/${tagId}/segment-distribution/${segment}/by-os-type/${dateRange}?segments=${segmentIds}`
    : `insights/${tagId}/segment-distribution/${segment}/by-os-type/${dateRange}`;
  if (page) {
    url = pushParamsToUrl(url, "page", page);
  }
  if (granularity) {
    url = pushParamsToUrl(url, "granularity", granularity);
  }

  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_TOP_5_OS_BREAKDOWN_REPORT, url);
  };
};

export const getSegmentDistributionDetailReport = (
  tagId,
  segment,
  dateRange,
  segmentIds,
  page,
  granularity,
) => {
  //Age = 101, Gender = 102, Marital Status = 103, Home Owner = 201, Income = 202, Length of Residence = 206,State = 1
  const ids = [1, 101, 102, 103, 201, 202, 206];
  let url = segmentIds
    ? `insights/${tagId}/segment-distribution/${segment}/demographics/${dateRange}?segments=${segmentIds}`
    : `insights/${tagId}/segment-distribution/${segment}/demographics/${dateRange}`;
  if (page) {
    if (url.indexOf("?segments=") > 0) {
      url += `&page=${encodeURIComponent(page)}`;
    } else {
      url += `?page=${encodeURIComponent(page)}`;
    }
  }
  url = pushParamsToUrl(url, "granularity", granularity);

  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_SEGMENT_DISTRIBUTION_DETAIL_REPORT, url);
  };
};

export const getSegmentDistributionDeviceModelReport = (
  tagId,
  segment,
  dateRange,
  segmentIds,
  granularity,
  page,
) => {
  let url = segmentIds
    ? `insights/${tagId}/segment-distribution/${segment}/by-device-model/${dateRange}?segments=${segmentIds}`
    : `insights/${tagId}/segment-distribution/${segment}/by-device-model/${dateRange}`;
  if (page) {
    if (url.indexOf("?segments=") > 0) {
      url += `&page=${page}`;
    } else {
      url += `?page=${page}`;
    }
  }
  url = pushParamsToUrl(url, "granularity", granularity);
  return (dispatch, getState) => {
    callApi(
      dispatch,
      getState,
      GET_SEGMENT_DISTRIBUTION_DEVICE_MODEL_REPORT,
      url,
    );
  };
};

export const getSegmentDistributionDeviceTypeReport = (
  tagId,
  segment,
  dateRange,
  segmentIds,
  granularity,
  page,
) => {
  let url = segmentIds
    ? `insights/${tagId}/segment-distribution/${segment}/by-device-type/${dateRange}?segments=${segmentIds}`
    : `insights/${tagId}/segment-distribution/${segment}/by-device-type/${dateRange}`;
  if (page) {
    if (url.indexOf("?segments=") > 0) {
      url += `&page=${page}`;
    } else {
      url += `?page=${page}`;
    }
  }
  url = pushParamsToUrl(url, "granularity", granularity);
  return (dispatch, getState) => {
    callApi(
      dispatch,
      getState,
      GET_SEGMENT_DISTRIBUTION_DEVICE_TYPE_REPORT,
      url,
    );
  };
};

export const getInsightsMostPopularPages = (tagId, dateRange) => {
  const url = `insights/${tagId}/most-popular-pages/${dateRange}`;
  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_INSIGHTS_POPULAR_PAGES, url);
  };
};

export const setPageFavorite = (tagId, dateRange, pageUrl, favorited) => {
  const url = `insights/${tagId}/toggle-favorite-page `;
  const postData = {
    pageUrl: pageUrl,
    toggleAdd: favorited,
  };
  return (dispatch, getState) => {
    callApi(dispatch, getState, SET_PAGE_FAVORITE, url, {
      method: "POST",
      body: JSON.stringify(postData),
    });
  };
};

export const getFavoritePages = tagId => {
  const url = `insights/${tagId}/favorite-pages`;
  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_FAVORITE_PAGES, url);
  };
};

export const saveFavoritePage = (tagId, pages) => {
  const url = `insights/${tagId}/favorite-pages`;
  const postData = pages;
  return (dispatch, getState) => {
    callApi(
      dispatch,
      getState,
      SAVE_FAVORITE_PAGES,
      url,
      {
        method: "POST",
        body: JSON.stringify(postData),
      },
      {
        success: () => {
          dispatch(getFavoritePages(tagId));
        },
      },
    );
  };
};

export const getStates = (siteId, dateRange, page, type) => {
  const typeParam = type
    ? type.toLowerCase() === "consumer"
      ? "c"
      : "b"
    : null;
  let url = `insights/${siteId}/visits/by-states/${dateRange}`;
  if (page) {
    url += `?p=${page}`;
  }
  if (typeParam) {
    if (page) url += `&t=${typeParam}`;
    else url += `?t=${typeParam}`;
  }
  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_BY_STATES, url);
  };
};

export const getSegmentDistributionSystems = (siteId, callback) => {
  const url = `insights/${siteId}/segment-distribution/systems`;
  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_SEGMENT_DISTRIBUTION_SYSTEMS, url).then(
      res => {
        callback && callback(res);
      },
    );
  };
};

export const getCultureCodeReport = (
  tagId,
  segment,
  dateRange,
  segments,
  page,
  granularity,
) => {
  let url = `insights/${tagId}/segment-distribution/${segment}/culturecode/${dateRange}`;
  if (segments) {
    url += "?segments=" + segments;
  }
  if (page) {
    if (url.includes("?")) url += "&page=" + encodeURIComponent(page);
    else url += "?page=" + page;
  }
  url = pushParamsToUrl(url, "granularity", granularity);
  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_CULTURE_CODE_REPORT, url);
  };
};

export const getDistributionHeatMapData = (
  tagId,
  segment,
  dateRange,
  segmentIds,
  page,
  granularity,
) => {
  let url = `insights/${tagId}/segment-distribution/${segment}/heat-map/${dateRange}`;
  if (segmentIds) {
    url += "?segments=" + segmentIds;
  }
  if (page) {
    if (url.includes("?")) url += "&page=" + encodeURIComponent(page);
    else url += "?page=" + page;
  }
  url = pushParamsToUrl(url, "granularity", granularity);
  return (dispatch, getState) => {
    callApi(dispatch, getState, GET_HEATMAP_DATA, url);
  };
};



// WEBPACK FOOTER //
// ./src/actions/Insights.js